import { Grid, Typography } from '@mui/material';

import { Skeleton } from '@mui/material';
import { utils } from '../../../../utils/utils';
import { Box } from '@arredo/reactjs-ui';

const InvoiceData = ({ invoice, title }) => {
    return (
        <Box header={<Grid container direction='column' size={12}>
            <Typography>
                {title}
            </Typography>
        </Grid>}
        >
            <Grid size={12}>
                <Grid container spacing={1} direction='column'>

                    <Grid container spacing={1} size={12}>
                        <Grid size={6}>
                            {
                                invoice.number
                                    ? <Typography color='primary' variant='body1'><strong>{`${invoice.typeToShow} Nro `}</strong>{`${invoice.billingCode}-${utils.formatVoucherNumber(invoice.number)}`}</Typography>
                                    : <Skeleton width={180} height={25} />
                            }
                        </Grid>
                        <Grid container justifyContent='flex-end' size={6}>
                            {
                                invoice.created
                                    ? <Typography align='right' variant='body1'><strong>Fecha: </strong>{utils.formatDate(invoice.created)}</Typography>
                                    : <Skeleton width={180} height={25} />
                            }
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
}

export default InvoiceData